// extracted by mini-css-extract-plugin
export default {"NavbarElement":"NavbarElement_NavbarElement__O-g4i"};